import React from 'react';

// Same stroke + opacity as the hero construction lines, so the pages feel related.
const STROKE = '#5e2a56';
const OPACITY = 0.06;
function boltCircle(cx: number, cy: number, r: number, holes: number, holeR: number) {
  return Array.from({
    length: holes
  }, (_, i) => {
    const a = i / holes * Math.PI * 2 - Math.PI / 2;
    return <circle key={i} cx={cx + Math.cos(a) * r} cy={cy + Math.sin(a) * r} r={holeR} data-id="element-11" data-mp="3fpklkzj7rn01" />;
  });
}
function centreMark(cx: number, cy: number, size: number) {
  return <path d={`M${cx - size} ${cy}H${cx + size}M${cx} ${cy - size}V${cy + size}`} data-id="element-12" data-mp="36ow6s2lzxim3" />;
}

/** Very faint drafting geometry behind the Über-mich page (wide screens only). */
export function AboutBlueprint() {
  return <svg className="pointer-events-none absolute inset-0 hidden h-full w-full lg:block" viewBox="0 0 1360 2400" preserveAspectRatio="xMidYMin slice" aria-hidden="true" data-id="element-13" data-mp="2wsb2xklpqdju">
      <g fill="none" stroke={STROKE} strokeOpacity={OPACITY} strokeWidth="1" data-id="element-14" data-mp="v0xy0vjqw5ns">
        {/* Concentric circles behind the portrait (top right) */}
        <circle cx="1130" cy="330" r="300" data-id="element-15" data-mp="28rftcyq18bgp" />
        <circle cx="1130" cy="330" r="230" strokeDasharray="24 6 3 6" data-id="element-16" data-mp="2dopsx774y3i9" />
        <circle cx="1130" cy="330" r="160" strokeDasharray="2 6" data-id="element-17" data-mp="1yr6ybo7s0w2w" />
        {boltCircle(1130, 330, 300, 12, 7)}
        <path d="M790 330H1360M1130 0V700" strokeDasharray="24 6 3 6" data-id="element-18" data-mp="23pqipk6q1zt5" />

        {/* Large sweep from the left edge through the intro */}
        <path d="M-80 760 A700 700 0 0 1 620 60" data-id="element-19" data-mp="2rh5s1wwx1hdw" />
        <path d="M0 0 L520 640" strokeDasharray="1 5" data-id="element-20" data-mp="2weo1doeuhymf" />

        {/* Small flange near the timeline (left) */}
        <circle cx="90" cy="1180" r="70" data-id="element-21" data-mp="2hqktg9h8scuz" />
        <circle cx="90" cy="1180" r="26" data-id="element-22" data-mp="2hpi260g0c8ej" />
        {boltCircle(90, 1180, 48, 6, 5)}
        {centreMark(90, 1180, 100)}

        {/* Horizontal datum line with ticks across the timeline */}
        <line x1="0" y1="960" x2="1360" y2="960" strokeDasharray="2 6" data-id="element-23" data-mp="3adx7twd91ed7" />

        {/* Arcs framing the video section (bottom) */}
        <path d="M-40 2300 A760 760 0 0 1 1400 2300" data-id="element-24" data-mp="3f7i2pfjjps86" />
        <path d="M1420 1700 A420 420 0 0 0 1060 2340" data-id="element-25" data-mp="3p0cocukvikne" />
        <circle cx="1250" cy="1560" r="54" strokeDasharray="2 6" data-id="element-26" data-mp="3k2b446bpofac" />
        {centreMark(1250, 1560, 80)}
      </g>
    </svg>;
}